<template>
  <div v-show="messageModal" class="modal is-active">
    <div class="modal-background"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title"><b>Message!</b></p>
          <button class="delete" aria-label="close" @click="$emit('close')"></button>
        </header>
        <section class="modal-card-body">
          <div>
            <p class="subtitle is-6" align="left"><b>Date: </b>{{ message.date }}</p>
            <p class="subtitle is-6" align="left"><b>Subject: </b>{{ message.subject }}</p>
            <p class="subtitle is-6" align="left"><b>Message: </b></p>
            <p class="subtitle is-6" align="left" v-html="message.message"> {{ message.message }} </p>
          </div>
        </section>
        <footer class="modal-card-foot">
          <button class="button is-fullwidth" @click="dismissMessage">Dismiss</button>
          <button class="button is-light is-fullwidth" @click="$emit('close')">Close</button>
        </footer>
      </div>
    </div>
</template>

<script>
  import * as firebase from 'firebase'
  import moment from 'moment'

  export default {
    name: 'messageModal',
    data() {
      return {
        messageModal: true,
        message: {
          key: '',
          date: '',
          subject: '',
          message: '',
        }
      }
    },
    methods: {
      dismissMessage(){
        firebase.database().ref('users').
        child(this.$store.getters.user.id).
        child('messages').child(this.message.key).update({
          dismissed:true,
        })
        this.$emit('close');
      },
    },
    mounted () {
      // listen for the event when the user is found by email
      this.$root.$on('currentMessage', currentMessage => {
        this.message.key = currentMessage.key
        this.message.date = currentMessage.date
        this.message.subject = currentMessage.subject
        this.message.message = currentMessage.message
      })
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Inbox/messageModal.vue